import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/TzaDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";


const initailEvknData: any = {
  idx : -1,

  task: "simpleqa",
  data_sources: "",
  category: "",
  subcategory: "",
  bmk_pk: "",
  difficulty: "",
  keyword: "",
  title: "",
  text: "",
  
  qa_type: "",
  answer_type: "",
  science_fact: "",
  common_knowledge: "",
  
  activity: "",
  question_a: "",
  question_b: "",
  question: "",

  answer: "",
  answer_index: "",

  option_1: "",
  option_2: "",
  option_3: "",
  option_4: "",
  option_5: "",

  reason_1: "",
  reason_2: "",
  reason_3: "",
  reason_4: "",
  reason_5: "",

  job_user:"",
  job_date:"",
  des:"",
};

const newInitailData: any = {
  sentence: [],
  question: "",
  answer: "",
  reason_path: [],
  des: ""
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const EvltCreatePage = (props: any) => {

  const [pageType, setPageType] = useState("new")

  const [search_doc_id, setSearch_doc_id] = useState("")

  const [evkn_detail_data, setEvkn_detail_data] = useState<any>(initailEvknData);

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [evknWorkList, setEvknWorkList] = useState([]);

  const [sentencesList, setSentencesList] = useState<any>([]);

  const [idx, setIdx] = useState('');
  const [job_yn, setJob_yn] = useState('모두');
  const [gub_cd, setGub_cd] = useState('모두');


  const [backdrop, setBackdrop] = useState<boolean>(false)

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const createInsertSentence = async () => {

    const formDataNew = new FormData();

    formDataNew.append("email", email);

    formDataNew.append("worker", worker);

    const newInsertSentencesData = {
      ...newData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      sentence: Array.isArray(sentenceInfo) ? sentenceInfo : (() => {
        try { return JSON.parse(sentenceInfo as string); } catch { return []; }
      })(),
    };

    formDataNew.append("insertSentences", JSON.stringify(newInsertSentencesData));

    // console.log('new data ?? ' , JSON.stringify(newInsertSentencesData))

    // return ;

    setBackdrop(true)

    await api.post("/createInsertSentence",formDataNew)
    .then((res:any) => {alert("데이터 입력 완료"); setPageType("update"); setBackdrop(false); getEvknWorkInsertSentenceList();})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }


  const updateInsertSentenceData = async () => {

    setBackdrop(true)
    
    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    const updatedInsertSentencesData = {
      ...colEvltData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      sentence: Array.isArray(sentenceInfo) ? sentenceInfo : (() => {
        try { return JSON.parse(sentenceInfo as string); } catch { return []; }
      })(),
    };

    // console.log('업데이트 내용',JSON.stringify(updatedInsertSentencesData))
    // return;
    
    formData.append("insertSentences", JSON.stringify(updatedInsertSentencesData));

    await api.post("/updateInsertSentencesData",formData)
    .then((res:any) => {alert(colEvltData.document_id + " 데이터 검수 완료"); setPageType("update"); setBackdrop(false); getEvknWorkInsertSentenceList();})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  const [newData, setNewData] = useState<any>(newInitailData);

  const [colEvltData, setColEvltData] = useState<any>([]);

  const [reason_path, setReason_path] = useState<any>([]);

  const reason_path_change = (idx: number, val: string) => {
    setReason_path((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const handleAdd = () => setReason_path((prev) => [...prev, ""]);
  const handleRemove = (idx: number) => setReason_path((prev) => prev.filter((_, i) => i !== idx));

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getEvknWorkInsertSentenceList = async () => {
    
    // email != 'hafrica@hufs.ac.kr'

    setBackdrop(true)
    api.get('/evltWorkInsertSentencesList',{params:{email:email, type:"LIST", worker:worker, page:page, order:order, job_yn:job_yn, gub_cd:gub_cd, idx:idx}})
    .then((res:any) => {
      
      // console.log('리턴 데이터', res.data)
      if(res.data.datas.length > 0){
        // setInstructionList(res.data);
        // setData(res.data.datas[0]);
        setEvknWorkList(res.data.datas);

        // console.log('리스트',res.data.datas)

        if((colEvltData && colEvltData.idx == -1) || (pagination && page != pagination.current_page)){
          setColEvltData(res.data.datas[0])
        }

        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        // console.log('api 리턴 데이터', res.data)
        setEvknWorkList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      // setPagination(res.data.pagination); 
      })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }
  
  const [selectSentence, setSelectSentence] = useState<any>(undefined);
  const [sentenceInfo, setSentenceInfo] = useState<any>([]);
  
  const handleAddSentence = () => {
    setSentenceInfo(prev => {
      const newIndex = prev.length;   // 추가될 새 문장의 인덱스
      setSelectSentence(newIndex);    // 바로 새 문장을 선택 상태로
      return [...prev, ""];           // 빈 문자열로 새 문장 추가
    });
  }

  const handleRemoveSentence = (index: number) => {
    setSentenceInfo((prev) => prev.filter((_, i) => i !== index));
    // 선택된 문장이 삭제된 경우 selectSentence 초기화
    if (selectSentence === index) {
      setSelectSentence(undefined);
    }
  };

  const sentence_change = (idx: number, val: string) => {
    setSentenceInfo((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  }
  
  // 작업 목록 클릭
  const getSentencesData = async (data:any) => {
    
    // console.log('데이터?? ' , data)

    setSentenceInfo(JSON.parse(data.sentence))
    setReason_path(JSON.parse(data.reason_path));
    setColEvltData(data)

  }

  useEffect(() => {
    if(selectSentence != undefined){
      setPageType("update")
    }

    if(props.rowDetail != undefined){
      if(props.rowDetail.instruction_data == 'Y'){
        // getPrcDetail(props.rowDetail.idx)
        // getSwInstructionDetail(props.rowDetail.idx)
        setPageType("update")
      }else{
        setPageType("new")
      }
    }
    getEvknWorkInsertSentenceList()
  }, [page, props.rowDetail]);

  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop message={"처리중..."}/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>장문 - 문장 삽입</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">
        {pageType === "update" &&
          <Box display="flex">
            <Box sx={{width:"100%"}}>
              <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
                <Box sx={{margin:"4px"}}>
                  <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                    <Box>
                      <Box display="flex" justifyContent="center">
                        <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>문장 삽입</Box>
                        <Box><Button sx={{marginLeft:"8px", backgroundColor:"#4b57fd"}} variant="contained" onClick={()=> {setPageType("new"); setReason_path([]); setSentenceInfo([]);}}>신규작성</Button></Box>
                        <Box><Button sx={{marginLeft:"16px", backgroundColor:"#fdb04b"}} variant="contained" onClick={handleAddSentence}>문장 추가</Button></Box>
                      </Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea spellCheck="false" value={colEvltData.question || ""} onChange={(e) => {setColEvltData({ ...colEvltData, question: e.target.value });}} style={{border:"4px solid #000", width:"740px",minHeight:"20px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{width:"420px"}}>
                  <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                      <Box><textarea spellCheck="false" value={colEvltData.answer || ""} onChange={(e) => {setColEvltData({ ...colEvltData, answer: e.target.value });}} style={{border:"4px solid #000", width:"740px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{width:"420px"}}>
                  <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Sentence</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                      <Box><textarea spellCheck="false" value={sentenceInfo[selectSentence] || ""} onChange={(e) => sentence_change(selectSentence, e.target.value)} style={{border:"4px solid #000", width:"740px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{width:"100%", marginTop: "16px"}}>
                  <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                    <Box sx={{margin:"4px 4px 4px 4px"}}>
                      <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"4px", width:"420px"}}>
                        <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                        </Box>
                        <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                      </Box>
                    </Box>
    
                    <Box sx={{width:"750px",margin:"4px", height:"200px", overflow:"auto"}}>
                      <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                          {reason_path && reason_path.map((item:any, index:any) => 
                            <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                              <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                              <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"640px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                              <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Box>
                    
                    <Box display="flex">
                      <Box sx={{display:"flex", marginTop:"16px"}}>
                        <Box sx={{display:"flex",marginLeft:"4px"}}>
                          <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                          <Box><textarea value={(colEvltData.des === "None" ? "" : colEvltData.des) || ""} onChange={(e) => {setColEvltData({ ...colEvltData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                      
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateInsertSentenceData();
                            }}
                          >
                            저장
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                    
                  </Paper>
                </Box>
                
              </Paper>
            </Box>
            {/* 삽입문장 리스트 */}
            <Box sx={{width:"100%"}}>
              <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
                <Box display="flex" justifyContent="center" >
                  <Box sx={{padding:"4px 8px 8px 8px", width:"600px"}}>
                    <Box display="flex">
                      <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>문장목록</Box>
                    </Box>
                    <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
                    <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
                      <Table size="small" aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>SEQ</Box></TableCell>
                            <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>문장</Box></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        {(sentenceInfo.length > 0) ? sentenceInfo.map((row:any, index:number) => (
                          <TableRow
                            key={index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(selectSentence != undefined && selectSentence === index ? "#dbdbef": "#fff")}}
                            onClick={()=> {setSelectSentence(index);}}
                          >
                            <TableCell component="th" scope="row" align="center">{index+1}</TableCell>
                            <TableCell component="th" scope="row" align="center">{row}</TableCell>
                            <TableCell component="th" scope="row" align="center">
                              <DangerousRoundedIcon sx={{fontSize:"20px", marginLeft:"8px", color:"red"}} onClick={() => handleRemoveSentence(index)}>✕</DangerousRoundedIcon>
                            </TableCell>
                          </TableRow>
                          )):<TableRow><TableCell colSpan={2} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  
                  
                </Box>
              </Paper>
            </Box>
          </Box>
        }

        {pageType === "new" &&
          <Box display="flex">
            <Box sx={{width:"100%"}}>
              <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
                <Box sx={{margin:"4px"}}>
                  <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                    <Box>
                      <Box display="flex" justifyContent="center">
                        <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>문장 삽입 (신규)</Box>
                        <Box><Button sx={{marginLeft:"8px", backgroundColor:"#fdb04b"}} variant="contained" onClick={handleAddSentence}>문장 추가</Button></Box>
                      </Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea spellCheck="false" value={newData.question || ""} onChange={(e) => {setNewData({ ...newData, question: e.target.value });}} style={{border:"4px solid #000", width:"740px",minHeight:"20px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{width:"420px"}}>
                  <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                      <Box><textarea spellCheck="false" value={newData.answer || ""} onChange={(e) => {setNewData({ ...newData, answer: e.target.value });}} style={{border:"4px solid #000", width:"740px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{width:"420px"}}>
                  <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Sentence</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                      <Box><textarea spellCheck="false" value={sentenceInfo[selectSentence] || ""} onChange={(e) => sentence_change(selectSentence, e.target.value)} style={{border:"4px solid #000", width:"740px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{width:"100%", marginTop: "16px"}}>
                  <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                    <Box sx={{margin:"4px 4px 4px 4px"}}>
                      <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"4px", width:"420px"}}>
                        <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                        </Box>
                        <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                      </Box>
                    </Box>
    
                    <Box sx={{width:"750px",margin:"4px", height:"200px", overflow:"auto"}}>
                      <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                          {reason_path && reason_path.map((item:any, index:any) => 
                            <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                              <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                              <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"640px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                              <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Box>
                    
                    <Box display="flex">
                      <Box sx={{display:"flex", marginTop:"16px"}}>
                        <Box sx={{display:"flex",marginLeft:"4px"}}>
                          <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                          <Box><textarea value={(newData.des === "None" ? "" : newData.des) || ""} onChange={(e) => {setNewData({ ...newData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                        </Box>
                      </Box>
                      
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              createInsertSentence();
                            }}
                          >
                            신규입력
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                    
                  </Paper>
                </Box>
                
              </Paper>
            </Box>
            {/* 삽입문장 리스트 */}
            <Box sx={{width:"100%"}}>
              <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
                <Box display="flex" justifyContent="center" >
                  <Box sx={{padding:"4px 8px 8px 8px", width:"600px"}}>
                    <Box display="flex">
                      <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>문장목록</Box>
                    </Box>
                    <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
                    <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
                      <Table size="small" aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>SEQ</Box></TableCell>
                            <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>문장</Box></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        {(sentenceInfo.length > 0) ? sentenceInfo.map((row:any, index:number) => (
                          <TableRow
                            key={index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(selectSentence != undefined && selectSentence === index ? "#dbdbef": "#fff")}}
                            onClick={()=> {setSelectSentence(index);}}
                          >
                            <TableCell component="th" scope="row" align="center">{index+1}</TableCell>
                            <TableCell component="th" scope="row" align="center">{row}</TableCell>
                            <TableCell component="th" scope="row" align="center">
                              <DangerousRoundedIcon sx={{fontSize:"20px", marginLeft:"8px", color:"red"}} onClick={() => handleRemoveSentence(index)}>✕</DangerousRoundedIcon>
                            </TableCell>
                          </TableRow>
                          )):<TableRow><TableCell colSpan={2} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  
                  
                </Box>
              </Paper>
            </Box>
          </Box>
        }

      <Box>

        {/* 작업목록 */}
        <Box display="flex" justifyContent="center" >
          <Box sx={{padding:"4px 8px 8px 8px", width:"368px"}}>
            <Box display="flex">
              <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} /></Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>작업목록</Box>
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>검수</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>유형</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                {(evknWorkList != undefined && evknWorkList.length > 0) ? evknWorkList.map((row:any, index:number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(colEvltData != undefined && row.idx === colEvltData.idx ? "#dbdbef": "#fff")}}
                    onClick={()=> {getSentencesData(row); setPageType("update"); }}
                  >
                    <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.job_yn === "Y" ? "2px solid #27cc2f" : (row.job_yn === "P" ? "2px solid #7427cc" : "#000")), color:"#000" }}>
                        {(row.job_yn === "Y" ? "완료" : (row.job_yn === "P" ? "X" : "미작업"))}
                      </Box>
                    </TableCell>
                  </TableRow>
                  )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{marginTop:"12px"}}>
              {pagination !== undefined ? (
                  <>
                  <CustomPagination pagination={pagination} goPage={goPage} />
                  <Box display="flex">
                    <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                      sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                      InputProps={{
                        style: {width: "60px", height:"23px", fontSize:"12px"},
                        inputProps: { 
                          spellCheck: "false" // spellcheck를 false로 설정
                        },
                      }}
                    />
                    <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>setPage(Number(c_page))}>
                      이동
                    </Button>
                  </Box>
                  </>
              ) : ""}
            </Box>
          </Box>
          
          
        </Box>
      </Box>
      </Box>
    </Paper>
  );
  
  
};

export default EvltCreatePage;
